import { render } from "./ChangeOfferingForVolume.vue?vue&type=template&id=3255c7d2&scoped=true"
import script from "./ChangeOfferingForVolume.vue?vue&type=script&lang=js"
export * from "./ChangeOfferingForVolume.vue?vue&type=script&lang=js"

import "./ChangeOfferingForVolume.vue?vue&type=style&index=0&id=3255c7d2&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3255c7d2"]])

export default __exports__